const { isOfflineError, isRecoverableServerError } = require('utils/network');
const { isInvalidApiTokenError } = require('utils/auth-error');
const Storage = require('utils/storage');
const PersistenceConfig = require('utils/persistence-config');

const internals = {};

module.exports = {
    recoverFromBootstrapError,
    shouldPreserveSession
};

function recoverFromBootstrapError({
    actions,
    authActions,
    error,
    logContext,
    redux,
    selectors
}) {

    console.error(logContext, {
        path: window.location.pathname,
        hasNearpeerToken: selectors.getIsAuthenticated(redux.getState()),
        error: {
            name: error?.name,
            message: error?.message,
            stack: error?.stack,
            code: error?.code,
            responseStatus: error?.response?.status,
            responseData: error?.response?.data
        }
    });

    redux.dispatch(actions.app.setMainAppLoading({ appLoading: false }));

    const state = redux.getState();
    const activeToken = selectors.getIsAuthenticated(state)
        ? selectors.getApiToken(state)
        : null;

    if (shouldPreserveSession(error, { activeToken })) {
        if (!internals.isE2E()) {
            redux.dispatch(actions.alerts.notification.push({
                message: internals.getPreservedSessionMessage(error)
            }));
        }
        return undefined;
    }

    return redux.dispatch(authActions.logoutSync());
}

function shouldPreserveSession(error, { activeToken } = {}) {

    if (isInvalidApiTokenError(error, { activeToken })) {
        return false;
    }

    if (isOfflineError(error)) {
        return true;
    }

    return true;
}

internals.isE2E = () => {

    if (process.env.PLAYWRIGHT_E2E === 'true') {
        return true;
    }

    if (typeof window === 'undefined') {
        return false;
    }

    return Storage.getItem(PersistenceConfig.keys.e2e.mockCommunication) === '1';
};

internals.getPreservedSessionMessage = (error) => {

    if (isOfflineError(error)) {
        return 'We could not refresh your session because the connection was interrupted. You are still signed in. Please try again when your connection improves.';
    }

    if (isRecoverableServerError(error)) {
        return 'Nearpeer is temporarily unavailable. You are still signed in. Please try again shortly.';
    }

    return 'We could not finish loading your account. You are still signed in. Please try again.';
};
